import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://cofoundwith.us";
const DEFAULT_DESCRIPTION =
  "Just the right prompts — in the right order. Co-Found with AI is the step-by-step playbook for founders building with AI as their co-founder.";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

interface SeoProps {
  title: string;
  description?: string;
  ogImage?: string;
  path?: string;
}

const setMeta = (
  key: string,
  content: string,
  attr: "name" | "property" = "property"
) => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href: string) => {
  let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const Seo = ({ title, description, ogImage, path }: SeoProps) => {
  const location = useLocation();
  const pathname = path ?? location.pathname;
  const desc = description || DEFAULT_DESCRIPTION;
  const image = ogImage || DEFAULT_OG_IMAGE;
  const url = `${SITE_URL}${pathname}`;

  useEffect(() => {
    document.title = title;
    setMeta("description", desc, "name");
    setMeta("og:title", title);
    setMeta("og:description", desc);
    setMeta("og:image", image);
    setMeta("og:url", url);
    setMeta("og:type", "website");
    setMeta("twitter:card", "summary_large_image", "name");
    setMeta("twitter:title", title, "name");
    setMeta("twitter:description", desc, "name");
    setMeta("twitter:image", image, "name");
    setCanonical(url);
  }, [title, desc, image, url]);

  return null;
};

export default Seo;
